import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const formControlDefaultVariants = {
  "isValid": false,
  "isInvalid": false
}
const formControlCompoundVariants = []

const formControlSlotNames = [
  [
    "root",
    "FormControl__root"
  ],
  [
    "label",
    "FormControl__label"
  ],
  [
    "description",
    "FormControl__description"
  ],
  [
    "helpText",
    "FormControl__helpText"
  ],
  [
    "validation",
    "FormControl__validation"
  ]
]
const formControlSlotFns = /* @__PURE__ */ formControlSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, formControlDefaultVariants, getSlotCompoundVariant(formControlCompoundVariants, slotName))])

const formControlFn = memo((props = {}) => {
  return Object.fromEntries(formControlSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const formControlVariantKeys = [
  "isValid",
  "isInvalid"
]
const getVariantProps = (variants) => ({ ...formControlDefaultVariants, ...compact(variants) })

export const formControl = /* @__PURE__ */ Object.assign(formControlFn, {
  __recipe__: false,
  __name__: 'formControl',
  raw: (props) => props,
  variantKeys: formControlVariantKeys,
  variantMap: {
  "isValid": [
    "true"
  ],
  "isInvalid": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, formControlVariantKeys)
  },
  getVariantProps
})